"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = __importDefault(require("uuid"));
var dbname = "brp_zl_idb";
var dbversion = 4;
var storename = "screenshots";
var sortindex = "time";
exports.ScreenshotFormat = function () {
    if (window.zlurlparams.screenshotFormat) {
        return window.zlurlparams.screenshotFormat;
    }
    return "jpg";
};
exports.SupportScreenshotManagment = function () {
    return window.indexedDB !== null;
};
var createStore = function (db, upgradeTransaction) {
    var objectStore = null;
    if (!db.objectStoreNames.contains(storename)) {
        objectStore = db.createObjectStore(storename, { keyPath: "uuid" });
    }
    else {
        objectStore = upgradeTransaction.objectStore(storename);
        if (objectStore.keyPath !== "uuid") {
            objectStore = db.createObjectStore(storename, { keyPath: "uuid" });
        }
    }
    if (!objectStore.indexNames.contains(sortindex)) {
        objectStore.createIndex(sortindex, "timestamp", { unique: false });
    }
};
var db = undefined;
var openDB = function () {
    return new Promise(function (resolve, reject) {
        var idb = window.indexedDB.open(dbname, dbversion);
        idb.onerror = function (event) {
            console.error("IndexedDB error", event);
            reject(event);
        };
        idb.onupgradeneeded = function (event) {
            var db = event.target.result;
            var upgradeTrans = event.target.transaction;
            createStore(db, upgradeTrans);
        };
        idb.onblocked = function (event) {
            console.warn("IndexedDB upgrade blocked", event);
            reject(event);
        };
        idb.onsuccess = function (event) {
            if (!db) {
                db = event.target.result;
            }
            else if (event.target.result) {
                var dupdb = event.target.result;
                dupdb.close();
            }
            if (db) {
                resolve(db);
            }
        };
    });
};
var getDB = function () {
    if (db) {
        return new Promise(function (resolve) { resolve(db); });
    }
    return openDB();
};
var read = [];
var write = [];
var acquireRead = function (transactionid) {
    return new Promise(function (resolve) {
        if (write.length === 0) {
            console.log("lock read:", transactionid);
            read.push(transactionid);
            try {
                resolve(function () { console.log("unlock read:", transactionid); read = read.filter(function (id) { return id !== transactionid; }); });
            }
            catch (_a) { }
        }
        else {
            setTimeout(function () {
                acquireRead(transactionid).then(resolve);
            }, 10);
        }
    });
};
var acquireWrite = function (transactionid) {
    return new Promise(function (resolve) {
        if (read.length === 0 && write.length === 0) {
            console.log("lock write:", transactionid);
            write.push(transactionid);
            try {
                resolve(function () { console.log("unlock write:", transactionid); write = write.filter(function (id) { return id !== transactionid; }); });
            }
            catch (_a) { }
        }
        else {
            setTimeout(function () {
                acquireWrite(transactionid).then(resolve);
            }, 10);
        }
    });
};
var getObjectStore = function (mode) {
    return new Promise(function (resolve, reject) {
        if (window.indexedDB === undefined) {
            reject("IndexedDB not supported");
            return;
        }
        var lock = mode === 'readonly' ? acquireRead : acquireWrite;
        lock(uuid_1.default.v4()).then(function (unlock) {
            getDB().then(function (db) {
                var transaction = db.transaction(storename, mode);
                transaction.onabort = function (ev) { console.log("Transation aborted", ev); unlock(); };
                transaction.oncomplete = function (ev) { console.log("Transation completed", ev); unlock(); };
                transaction.onerror = function (ev) { console.log("Transation error", ev); unlock(); };
                resolve(transaction.objectStore(storename));
            }).catch(function (reason) {
                reject(reason);
                unlock();
            });
        });
    });
};
exports.SaveScreenshot = function (image, format, title, config) {
    return new Promise(function (resolve, reject) {
        getObjectStore("readwrite").then(function (objectStore) {
            var id = uuid_1.default.v4();
            config["shotid"] = id;
            var screenshot = {
                uuid: id,
                image: image,
                format: format,
                title: title,
                config: config,
                timestamp: Date.now()
            };
            var request = objectStore.add(screenshot);
            request.onerror = function (event) {
                reject("Failed to add screenshot to object store", event);
            };
            request.onsuccess = function (event) {
                if (db) {
                    db.close();
                    db = undefined;
                }
                resolve(event.target.result.toString());
            };
        }).catch(function (reason) {
            reject(reason);
        });
    });
};
exports.CountScreenshots = function () {
    return new Promise(function (resolve) {
        getObjectStore("readonly").then(function (objectStore) {
            var request = objectStore.count();
            request.onerror = function (event) {
                console.warn("Failed to count screenshots", event);
                resolve(0);
            };
            request.onsuccess = function (event) {
                resolve(event.target.result);
            };
        }).catch(function () {
            resolve(0);
        });
    });
};
exports.EnumerateScreenshots = function (start, max) {
    return new Promise(function (resolve) {
        getObjectStore("readonly").then(function (objectStore) {
            console.log("Enumerate Screenshots", { start: start, max: max });
            var index = objectStore.index(sortindex);
            var screenshots = [];
            var request;
            try {
                // this line doesn't work on IE 11 (raises DataError) and couldn't create a range object that seemed to satisfy.
                request = index.openCursor(undefined, "prev");
            }
            catch (err) {
                request = index.openCursor();
            }
            request.onerror = function (event) {
                console.warn("Failed to enumerate screenshots", event);
                resolve([]);
            };
            request.onsuccess = function (event) {
                var cursor = event.target.result;
                if (cursor) {
                    if (start) {
                        cursor.advance(start);
                        start = 0;
                    }
                    else if (max === undefined || screenshots.length < Math.floor(max)) {
                        var screenshot_1 = cursor.value;
                        if (screenshot_1.image && typeof (screenshot_1.image) === typeof (Blob)) {
                            screenshot_1.image = URL.createObjectURL(screenshot_1.image);
                            screenshot_1.release = function () {
                                URL.revokeObjectURL(screenshot_1.image);
                            };
                        }
                        if (!screenshot_1.format) {
                            screenshot_1.format = exports.ScreenshotFormat();
                        }
                        screenshots.push(screenshot_1);
                        cursor.continue();
                    }
                    else {
                        console.log("found " + screenshots.length + "/" + Math.floor(max) + "screenshots");
                        resolve(screenshots);
                    }
                }
                else {
                    if (screenshots.length === 0) {
                        console.log("found no screenshots");
                    }
                    else if (max !== undefined) {
                        console.log("found " + screenshots.length + "/" + Math.floor(max) + "screenshots");
                    }
                    else {
                        console.log("found " + screenshots.length + "screenshots");
                    }
                    resolve(screenshots);
                }
            };
        }).catch(function () {
            resolve([]);
        });
    });
};
exports.DeleteScreenshot = function (screenshot) {
    return new Promise(function (resolve, reject) {
        getObjectStore("readwrite").then(function (objectStore) {
            console.log("Delete screenshot");
            var request = objectStore.delete(screenshot.uuid);
            request.onerror = function (event) {
                console.warn("Failed to delete screenshot", event);
                reject();
            };
            request.onsuccess = function () {
                if (screenshot.release) {
                    screenshot.release();
                }
                if (db) {
                    db.close();
                    db = undefined;
                }
                resolve();
                console.log("Deleted screenshot");
            };
        }).catch(function (reason) {
            reject(reason);
        });
    });
};
//# sourceMappingURL=ScreenshotManager.js.map